import {
  AfterViewInit,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { filter } from 'rxjs';
import Aos from 'aos';

import { FooterComponent } from './core/layout/footer/footer.component';
import { NavBarComponent } from './core/layout/nav-bar/nav-bar.component';
import { ErrorModalComponent } from './shared/error-modal/error-modal.component';
import { LanguageService } from 'features/src/lib/donations/services/lenguage.service';
import { ZeffyPopupService } from './shared/zeffy-popup.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    TranslateModule,
    FooterComponent,
    NavBarComponent,
    ErrorModalComponent,
  ],
})
export class AppComponent implements OnInit, AfterViewInit {
  isNavFooter!: boolean;
  title = 'crezco-foundation';
  readonly zeffyPopupContent =
    this.zeffyPopupService.content;

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly languageService: LanguageService,
    private readonly zeffyPopupService: ZeffyPopupService
  ) {
    this.languageService.initLanguage();

    const lang =
      localStorage.getItem('lang') || 'en';

    localStorage.setItem('lang', lang);

    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        window.scrollTo(0, 0);
      });

    Aos.init({
      once: false,
      duration: 500,
      easing: 'ease',
    });

    window.addEventListener(
      'load',
      Aos.refresh
    );
  }

  ngAfterViewInit(): void {
    this.zeffyPopupService.openTemporaryCampaign();
  }

  closeZeffyPopup(
    event?: MouseEvent
  ): void {
    if (
      event &&
      event.target !== event.currentTarget
    ) {
      return;
    }

    this.zeffyPopupService.close(
      event?.currentTarget as HTMLElement | undefined
    );
  }
}